module.exports = __webpack_public_path__ + "static/media/closeCircleSvg.333104ed.svg";